import { useQuery } from '@tanstack/react-query';

import { getProfilePicture as getProfilePictureApi } from '../../services/apiUserProfile'
import { useSelector } from 'react-redux';
import { RootState } from '../../store';
import { useError } from '../../context/ErrorContext';

export function useProfilePicture(isProfileImageAvailable?: boolean) {
  const { handleErrorAction } = useError();
  const { user } = useSelector((state: RootState) => state.auth)
  let url = ''

  if (user?.isSuperAdminUser === true) {
    url = '/api/super/userDetails/readProfileImage'
  }

  if (user?.isSuperAdminUser === false && user?.isLoginUsingClientUrl === true) {
    url = '/api/client/common/userDetails/readProfileImage'
  }

  const { data: profilePicture, isLoading } = useQuery({
    queryKey: ["profilePicture"],
    queryFn: () => getProfilePictureApi(url),
    enabled: !!isProfileImageAvailable && !!url,
    onError: (error: Error) => {
      handleErrorAction(error)
    }
  });

  return { profilePicture, isLoading };
}